import { RuleSection } from '../types';
import { upgradeMiniChapters } from './perfect-quality-3';

const miniSectionsRaw: RuleSection[] = [
  {
    id: 'mini-flying',
    title: 'Maszyny latające',
    requiredModuleIds: ['mini-01-flying-machines'],
    editionTag: 'C3',
    sourceIds: ['bigbox-minis-c3', 'corpus-base'],
    keywords: ['maszyna', 'lot', 'kość', 'latająca'],
    level: 'intermediate',
    hubGroup: 'Minidodatki',
    content: [
      {
        type: 'heading',
        text: 'Przygotowanie',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Komponenty: 8 kafelków krajobrazu z maszynami latającymi oraz 1 kość lotu o ściankach 1, 1, 2, 2, 3, 3. Wymieszaj nowe kafelki z pozostałymi i ułóż stosy jak zwykle. Kość połóż w zasięgu wszystkich graczy.',
      },
      {
        type: 'heading',
        text: 'Przebieg tury — lot',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Po dołożeniu kafelka z maszyną latającą możesz normalnie umieścić meepla według zasad podstawy albo położyć go na maszynie latającej zamiast zwykłego umieszczenia.',
      },
      {
        type: 'numberedList',
        items: [
          'Połóż meepla na maszynie latającej na właśnie dołożonym kafelku.',
          'Meeple leci po linii prostej w kierunku wskazanym strzałką maszyny.',
          'Rzuć kością lotu i przesuń meepla o tyle kafelków, ile oczek (1–3).',
          'Na docelowym kafelku połóż meepla na dowolnym nieukończonym obszarze (droga, miasto, klasztor), nawet jeśli ten obszar jest już zajęty przez inne meeple — to wyjątek od normalnej reguły zajętości.',
        ],
      },
      {
        type: 'exception',
        text: 'Meeple z maszyny latającej nigdy nie ląduje na polu (łące), nawet jeśli pole jest puste. Natychmiast staje się podróżnikiem, rycerzem albo mnichem według wybranego obszaru.',
      },
      {
        type: 'warning',
        text: 'Nieudany lot: jeśli w miejscu wylądowania nie ma kafelka albo na docelowym kafelku nie ma legalnego celu (tylko ukończone obszary i/lub pola), meeple wraca do zapasu. W tej turze nie stawiasz innego meepla.',
      },
      {
        type: 'paragraph',
        text: 'Po udanym lądowaniu natychmiast sprawdź punktowanie ukończonych obszarów jak w zwykłej turze (etap punktowania po umieszczeniu figury).',
      },
      {
        type: 'example',
        title: 'Przykład lotu',
        text: 'Kładziesz kafelek z maszyną skierowaną w górę-lewo i wybierasz lot. Rzut 3: w tym miejscu nie ma kafelka — lot nieudany, meeple wraca. Przy rzucie 2 mógłbyś wylądować na zajętym klasztorze albo zajętym mieście; ukończona droga byłaby niedostępna.',
      },
      {
        type: 'heading',
        text: 'Punktowanie i koniec gry',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Figury umieszczone lotem punktują dokładnie jak zwykłe meeple danego typu. Na końcu gry nie ma osobnego punktowania maszyn latających — obowiązują standardowe zasady końcowe.',
      },
      {
        type: 'commonMistake',
        text: 'Traktowanie lotu jak zwykłego stawiania bez kości albo lądowanie na polu.',
      },
    ],
  },
  {
    id: 'mini-messengers',
    title: 'Kurierzy (minidodatek Wiadomości)',
    requiredModuleIds: ['mini-02-messengers'],
    editionTag: 'C3',
    sourceIds: ['bigbox-minis-c3'],
    keywords: ['wiadomość', 'kurier', 'ciemne pole', 'tor'],
    level: 'intermediate',
    hubGroup: 'Minidodatki',
    content: [
      {
        type: 'editionWarning',
        text: 'To NIE jest duże rozszerzenie Kurierzy i Burmistrzowie (major-05). Minidodatek Big Box dodaje tor wiadomości i osobne kafelki wiadomości.',
        oldEditionName: 'major-05',
      },
      {
        type: 'heading',
        text: 'Przygotowanie',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Komponenty: 8 kafelków wiadomości oraz 6 kurierów (po jednym na gracza). Wymieszaj kafelki wiadomości i ułóż je zakrytym stosem. Każdy gracz stawia kuriera swojego koloru na polu 0 toru punktacji obok swojego znacznika punktów — na torze leżą więc dwa znaczniki każdego gracza.',
      },
      {
        type: 'heading',
        text: 'Przebieg tury — wybór znacznika i wiadomości',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Ilekroć w swojej turze zdobywasz punkty (po dołożeniu kafelka i ewentualnym wystawieniu figury), musisz przesunąć albo swój znacznik punktów, albo swojego kuriera o zdobytą liczbę pól. Jeśli w trakcie Twojej tury (i tylko wtedy) znacznik punktów albo kurier zatrzyma się sam na ciemnym polu (0, 5, 10, 15…), natychmiast dobierz i rozstrzygnij jedną wiadomość.',
      },
      {
        type: 'bulletList',
        items: [
          'Rozstrzygnięcie: wykonaj akcję z kafelka wiadomości ALBO zdobądź 2 punkty (ikona w prawym dolnym rogu).',
          'W obu przypadkach odłóż kafelek zakryty na spód stosu.',
          'Przy punktowaniu obszarów dobierasz co najwyżej jedną wiadomość — nawet jeśli oba znaczniki wpadną na ciemne pola w tej samej turze.',
          'Jeśli punkty z samej wiadomości przesuną znacznik lub kuriera na ciemne pole, możesz dobrać i rozstrzygnąć drugą wiadomość.',
          'Dobierasz wiadomość tylko wtedy, gdy Twój znacznik lub kurier jest sam na ciemnym polu. Współdzielone pole z figurą innego gracza = brak dobrania.',
        ],
      },
      {
        type: 'heading',
        text: 'Efekty wiadomości (skrót Big Box)',
        level: 2,
      },
      {
        type: 'numberedList',
        items: [
          'Najkrótsza droga z Twoim podróżnikiem: punktuj jak na końcu gry (najsłabsza z Twoich dróg); figura zostaje.',
          'Najmniejsze miasto z Twoim rycerzem: analogicznie jak wyżej.',
          'Najmniejszy klasztor z Twoim mnichem: analogicznie jak wyżej.',
          'Dołóż jeden kafelek i opcjonalnie figurę według normalnych zasad.',
          '2 punkty za każdy herb w miastach, w których masz co najmniej jednego rycerza (nie musisz mieć większości).',
          '2 punkty za każdego Twojego rycerza (figury zostają).',
          '2 punkty za każdego Twojego chłopa (figury zostają).',
          'Wybierz obszar z Twoją figurą, punktuj jak na końcu gry tylko dla siebie (nawet bez większości), potem zabierz tę figurę do zapasu.',
        ],
      },
      {
        type: 'note',
        text: 'Z Karczmami i Katedrami: wiadomość o niepełnej drodze z karczmą daje 0 pkt za tę drogę; wiadomość o niepełnym mieście z katedrą daje 0 pkt; przy wiadomościach liczących rycerzy/chłopów duży meeple liczy się jako 1. Z Kupcami: przy podwójnej turze budowniczego możesz dobrać wiadomość w każdym etapie punktowania, jeśli spełnisz warunek ciemnego pola.',
      },
      {
        type: 'heading',
        text: 'Punktowanie końcowe',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Przed punktowaniem końcowym zsumuj wynik znacznika punktów i kuriera, ustaw znacznik punktów na sumie, a kuriera zbierz do zapasu. Podczas punktowania końcowego nie dobiera się wiadomości.',
      },
      {
        type: 'commonMistake',
        text: 'Mylenie z major-05 albo dobieranie wiadomości przy współdzielonym ciemnym polu.',
      },
    ],
  },
  {
    id: 'mini-ferries',
    title: 'Promy',
    requiredModuleIds: ['mini-03-ferries'],
    editionTag: 'C3',
    sourceIds: ['bigbox-minis-c3'],
    keywords: ['prom', 'jezioro', 'przystań', 'droga'],
    level: 'intermediate',
    hubGroup: 'Minidodatki',
    content: [
      {
        type: 'heading',
        text: 'Przygotowanie',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Komponenty: 8 kafelków jezior z wieloma zakończeniami dróg oraz 8 drewnianych promów. Wymieszaj kafelki z pozostałymi; promy trzymaj w zasięgu graczy.',
      },
      {
        type: 'heading',
        text: 'Kolejność tury z promami',
        level: 2,
      },
      {
        type: 'resolutionOrder',
        title: 'Sekwencja tury',
        steps: [
          'Dołóż kafelek',
          'Umieść meepla (opcjonalnie)',
          'Wystaw nowy prom (jeśli dotyczy)',
          'Przestaw istniejący prom (jeśli dotyczy)',
          'Punktuj ukończone obszary',
        ],
      },
      {
        type: 'paragraph',
        text: 'Jeśli jako podróżnik stawiasz meepla na właśnie dołożonym kafelku jeziora, weź prom z zapasu i połóż go na jeziorze tak, by łączył dokładnie dwa odcinki dróg. Pozostałe odcinki na tym kafelku kończą się. Tylko odcinki połączone promem tworzą jedną drogę.',
      },
      {
        type: 'paragraph',
        text: 'Gdy przedłużasz drogę, na której już leży prom, możesz przestawić ten prom na tym samym jeziorze — zawsze musi łączyć dwa odcinki. Możesz odłączyć prom od właśnie przedłużanej drogi. Przy kilku promach na tej drodze przestawiasz tylko prom najbliższy właśnie dołożonego kafelka. Jeśli kafelek przedłuża drogę w więcej niż jednym kierunku (np. most), możesz przestawić dwa najbliższe promy, które należały do tej drogi.',
      },
      {
        type: 'warning',
        text: 'Każdy prom można wystawić albo przestawić tylko raz na turę. Gdy przedłużasz drogę z promem kafelkiem jeziora, najpierw wystaw nowy prom, a dopiero potem możesz przestawić istniejący.',
      },
      {
        type: 'note',
        text: 'Przestawienie promu może sprawić, że wcześniej ukończona i punktowana droga znów stanie się nieukończona. Jeziora z Karczm i Katedr nie współdziałają z jeziorami Promów. Droga z promem bez karczmy nadal daje 1 pkt/kafelek.',
      },
      {
        type: 'exception',
        text: 'Budowniczy (Kupcy i Budowniczowie): przestawienie promu, które przedłuża drogę z Twoim budowniczym, NIE daje podwójnej tury — potrzebujesz faktycznie dołożyć nowy kafelek na tę drogę.',
      },
      {
        type: 'heading',
        text: 'Punktowanie i koniec gry',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Po wystawieniu lub przestawieniu promu punktuj ukończone drogi i inne obszary jak zwykle. Na końcu gry nieukończone drogi z promami punktują według standardowych zasad końcowych; prom nadal wyznacza, które odcinki tworzą jedną drogę.',
      },
      {
        type: 'example',
        title: 'Przykład',
        text: 'Kładziesz jezioro, stawiasz podróżnika i ustawiasz prom tak, że łączysz się z niebieskim podróżnikiem — powstaje wspólna droga. Później przedłużasz tę drogę i przestawiasz prom, rozdzielając meeple na osobne drogi.',
      },
      {
        type: 'commonMistake',
        text: 'Traktowanie wszystkich odcinków jeziora jako jednej drogi bez promu albo przyznawanie podwójnej tury za samo przestawienie promu.',
      },
    ],
  },
  {
    id: 'mini-gold',
    title: 'Kopalnie złota',
    requiredModuleIds: ['mini-04-goldmines'],
    editionTag: 'C3',
    sourceIds: ['bigbox-minis-c3'],
    keywords: ['złoto', 'sztabka', 'ingot', 'kopalnia'],
    level: 'intermediate',
    hubGroup: 'Minidodatki',
    content: [
      {
        type: 'heading',
        text: 'Przygotowanie',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Komponenty: 8 kafelków ze złotem, 16 drewnianych sztabek oraz żeton/tabela punktacji złota. Wymieszaj kafelki z pozostałymi; sztabki trzymaj w zasięgu graczy.',
      },
      {
        type: 'heading',
        text: 'Kolejność tury',
        level: 2,
      },
      {
        type: 'resolutionOrder',
        title: 'Sekwencja z kopalniami',
        steps: [
          'Dołóż kafelek',
          'Połóż dwie sztabki (jeśli kafelek ma złoto)',
          'Umieść meepla',
          'Punktuj ukończone obszary',
          'Rozdaj sztabki ze scorowanego obszaru',
        ],
      },
      {
        type: 'paragraph',
        text: 'Gdy kładziesz kafelek ze złotem, połóż 1 sztabkę na tym kafelku oraz 1 sztabkę na wybranym sąsiednim kafelku (w tym po przekątnej). Sztabki nie leżą na konkretnych obszarach — leżą na kafelkach. Na jednym kafelku może leżeć dowolna liczba sztabek.',
      },
      {
        type: 'heading',
        text: 'Rozdawanie złota przy ukończeniu',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Gdy ukończysz jakikolwiek obszar (drogę, miasto, klasztor) na kafelku, na którym leży złoto, podczas punktowania tego obszaru rozdajesz złoto z tego kafelka ORAZ ze wszystkich kafelków należących do ukończonego obszaru. Dla drogi/miasta: wszystkie kafelki tego obszaru. Dla klasztoru: klasztor oraz 8 otaczających kafelków.',
      },
      {
        type: 'bulletList',
        items: [
          'Gracz z większością na scorowanym obszarze bierze wszystkie te sztabki.',
          'Przy remisie: zaczynając od aktywnego gracza i idąc zgodnie z ruchem wskazówek zegara, każdy remisujący bierze po 1 sztabce, aż nie zostanie żadna na tych kafelkach.',
          'Chłopi nigdy nie dostają złota — pola nie kończą się w trakcie gry, a nieodebrane sztabki zdejmuje się przed punktowaniem końcowym.',
        ],
      },
      {
        type: 'example',
        title: 'Przykład większości',
        text: 'Kończysz miasto z trzema sztabkami na jego kafelkach. Masz większości — bierzesz wszystkie 3.',
      },
      {
        type: 'example',
        title: 'Przykład remisu',
        text: 'Kończysz drogę z trzema sztabkami. Ty i niebieski macie remis większości. To Twoja tura: bierzesz 1, niebieski bierze 1, Ty bierzesz ostatnią.',
      },
      {
        type: 'example',
        title: 'Wiele kopalni na obszarze',
        text: 'Droga przechodzi przez dwa kafelki ze złotem i kilka sąsiadów, na których wcześniej położono sztabki. Przy ukończeniu drogi zbieracie wszystkie sztabki z każdego kafelka należącego do tej drogi — nie tylko z kafelka, który zamknął drogę.',
      },
      {
        type: 'heading',
        text: 'Punktowanie końcowe — tabela wartości sztabek',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Po zakończeniu gry, a przed punktowaniem końcowym, usuń z planszy wszystkie nieodebrane sztabki. Potem policz zebrane sztabki każdego gracza i porównaj z tabelą:',
      },
      {
        type: 'scoringTable',
        headers: ['Zebrane sztabki', 'Punkty za 1 sztabkę'],
        rows: [
          ['1–3', '1'],
          ['4–6', '2'],
          ['7–9', '3'],
          ['10 lub więcej', '4'],
        ],
      },
      {
        type: 'example',
        title: 'Przykład tabeli',
        text: 'Zebrałeś 7 sztabek → każda warta 3 punkty → 21 punktów ze złota. Przy 4 sztabkach: 4 × 2 = 8 punktów. Przy 10 sztabkach: 10 × 4 = 40 punktów.',
      },
      {
        type: 'commonMistake',
        text: 'Przyznawanie złota chłopom, liczenie tylko kafelka zamykającego albo pomijanie tabeli wartości na końcu.',
      },
    ],
  },
  {
    id: 'mini-mage',
    title: 'Mag i Wiedźma',
    requiredModuleIds: ['mini-05-mage-witch'],
    editionTag: 'C3',
    sourceIds: ['bigbox-minis-c3'],
    keywords: ['mag', 'wiedźma', 'magia', 'droga', 'miasto'],
    level: 'intermediate',
    hubGroup: 'Minidodatki',
    content: [
      {
        type: 'heading',
        text: 'Przygotowanie',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Komponenty: 8 kafelków z symbolem magii, 1 fioletowy Mag oraz 1 pomarańczowa Wiedźma. Wymieszaj kafelki; figury magiczne trzymaj w zasięgu graczy.',
      },
      {
        type: 'heading',
        text: 'Przebieg — wystawianie i przenoszenie',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Gdy kładziesz kafelek z symbolem magii, przed umieszczeniem meepla musisz wystawić albo przenieść jedną z figur magicznych. Figury wolno stawiać wyłącznie na nieukończonych miastach lub drogach i nigdy na tym samym obszarze jednocześnie. Nie muszą trafić na właśnie dołożony kafelek. Jeśli obie figury już leżą, musisz przenieść jedną z nich według tych samych zasad.',
      },
      {
        type: 'warning',
        text: 'Jeśli nie ma żadnego legalnego miejsca, zdejmij jedną figurę z planszy na bok — wróci przy kolejnym symbolu magii. Gdy Twoje dołożenie sprawi, że obie figury znajdą się na tym samym obszarze, natychmiast przenieś jedną (przed punktowaniem, jeśli obszar się kończy).',
      },
      {
        type: 'heading',
        text: 'Punktowanie',
        level: 2,
      },
      {
        type: 'bulletList',
        items: [
          'Mag: scorowany obszar (miasto lub droga) daje dodatkowo +1 punkt za każdy kafelek obszaru. Mag nie daje punktów za herby.',
          'Wiedźma: punkty scorowanego obszaru są dzielone na pół i zaokrąglane w górę.',
          'Przy karczmie/katedrze najpierw dolicz premię karczmy/katedry, potem połowę z Wiedźmą.',
          'Po zmodyfikowaniu wyniku figurę magiczną zdejmij na bok; wraca przy kolejnym symbolu.',
        ],
      },
      {
        type: 'example',
        title: 'Przykład Maga',
        text: 'Miasto 8 kafelków + 2 herby: normalnie (8+2)×2 = 20. Z Magiem każdy kontrolujący dostaje 20 + 8 = 28.',
      },
      {
        type: 'example',
        title: 'Przykład Wiedźmy',
        text: 'Droga 5 kafelków: połowa z 5 zaokrąglona w górę to 3 punkty. Droga 3 kafelków z Magiem: 3 + 3 = 6 punktów.',
      },
      {
        type: 'note',
        text: 'Karczmy i Katedry: nieukończona droga z karczmą i Magiem przy punktowaniu końcowym daje 0 za karczmę, ale Mag nadal dodaje 1 pkt/kafelek.',
      },
      {
        type: 'heading',
        text: 'Koniec gry',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Podczas punktowania końcowego Mag i Wiedźma nadal modyfikują wartość obszarów, na których stoją, dokładnie jak w trakcie gry.',
      },
      {
        type: 'commonMistake',
        text: 'Trzymanie Maga i Wiedźmy na tym samym obszarze albo zaokrąglanie połowy Wiedźmy w dół zamiast w górę.',
      },
    ],
  },
  {
    id: 'mini-robbers',
    title: 'Bandyci',
    requiredModuleIds: ['mini-06-robbers'],
    editionTag: 'C3',
    sourceIds: ['bigbox-minis-c3'],
    keywords: ['bandyta', 'rabuś', 'tor', 'kradzież'],
    level: 'intermediate',
    hubGroup: 'Minidodatki',
    content: [
      {
        type: 'heading',
        text: 'Przygotowanie',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Komponenty: 8 kafelków z workiem (symbolem bandyty) oraz 6 figur bandytów (po jednej na gracza). Wymieszaj kafelki; każdy gracz dokłada bandytę do swojego zapasu.',
      },
      {
        type: 'heading',
        text: 'Wystawianie bandytów na tor',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Gdy dobierasz kafelek z workiem, połóż go normalnie, a następnie ustaw swojego bandytę na torze punktacji na polu zajętym przez co najmniej jeden znacznik punktów innego gracza. Potem, w kolejności tur, każdy kolejny gracz, który jeszcze nie ma bandyty na torze (albo chce go przenieść), również ustawia/przenosi bandytę na pole z cudzym znacznikiem. Jeśli Twój bandyta już jest na torze, możesz go przenieść na inne pole.',
      },
      {
        type: 'heading',
        text: 'Kradzież punktów',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Gdy znacznik punktów, na którego polu stoi Twój bandyta, przesuwa się wskutek zdobycia punktów, bandyta „okrada” tę zdobycz: Ty zdobywasz połowę tych punktów zaokrągloną w górę (przesuwasz swój znacznik), a okradziony gracz zachowuje pełną wartość. Potem Twój bandyta wraca do Twojego zapasu.',
      },
      {
        type: 'bulletList',
        items: [
          'Musisz skorzystać z pierwszej okazji — nie wolno czekać na większą zdobycz.',
          'Nie możesz okraść samego siebie.',
          'Kilka znaczników na tym samym polu punktujących w tej samej turze: właściciel bandyty wybiera, którego okrada.',
          'Kilku bandytów na tym samym polu: każdy dostaje swoją połowę (zaokrągloną w górę) z tej samej zdobyczy.',
          'Honor wśród złodziei: jeśli punkty pochodzą z kradzieży bandyty, inni bandyci na polu okradającego nie dostają punktów — zamiast tego przesuwają się razem z jego znacznikiem na nowe pole.',
        ],
      },
      {
        type: 'example',
        title: 'Połowa w górę',
        text: 'Niebieski zdobywa 5 punktów; Twój bandyta na jego polu daje Ci 3 punkty (połowa z 5 w górę). Niebieski zachowuje pełne 5.',
      },
      {
        type: 'example',
        title: 'Wielu bandytów',
        text: 'Niebieski zdobywa 4 punkty; Ty i zielony macie bandytów na jego polu — każdy bierze 2, potem bandyci wracają do zapasów.',
      },
      {
        type: 'note',
        text: 'Interakcje: premie etapowe i bonusy rozszerzeń, które przesuwają znacznik punktów, też wyzwalają kradzież. Z minikurierami: jeśli Twoja kradzież przesunie znacznik lub kuriera na samotne ciemne pole, dobierasz wiadomość.',
      },
      {
        type: 'heading',
        text: 'Koniec gry',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Po zakończeniu gry, a przed punktowaniem końcowym, jeśli Twój bandyta nadal stoi na torze, zdobywasz 3 punkty, po czym zbierasz bandytę do zapasu. Potem następuje zwykłe punktowanie końcowe.',
      },
      {
        type: 'commonMistake',
        text: 'Czekanie z kradzieżą, branie połowy w dół albo pomijanie 3 punktów za bandytę pozostałego na torze przed finałem.',
      },
    ],
  },
  {
    id: 'mini-crops',
    title: 'Kręgi w zbożu',
    requiredModuleIds: ['mini-07-crop-circles'],
    editionTag: 'C3',
    sourceIds: ['bigbox-minis-c3'],
    keywords: ['kręgi', 'zboże', 'grabie', 'tarcza', 'maczuga'],
    level: 'intermediate',
    hubGroup: 'Minidodatki',
    content: [
      {
        type: 'heading',
        text: 'Przygotowanie',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Komponenty: 6 kafelków z kręgami w zbożu. Wymieszaj je z pozostałymi kafelkami. Kręgi oddzielają drogi i pola — meeple nie mogą stać na samym kręgu.',
      },
      {
        type: 'heading',
        text: 'Przebieg tury',
        level: 2,
      },
      {
        type: 'resolutionOrder',
        title: 'Sekwencja',
        steps: [
          'Dołóż kafelek',
          'Umieść meepla',
          'Punktuj ukończone obszary',
          'Wykonaj akcję kręgu w zbożu',
        ],
      },
      {
        type: 'paragraph',
        text: 'Po standardowej turze aktywny gracz, który dołożył kafelek z kręgiem, wybiera jedną z dwóch akcji (A albo B) według typu figur wskazanego na kafelku. Następnie wszyscy gracze — zaczynając od gracza po lewej aktywnego i idąc zgodnie z ruchem wskazówek zegara — muszą wykonać wybraną akcję; na końcu wykonuje ją także aktywny.',
      },
      {
        type: 'bulletList',
        items: [
          'A) Dołóż meepla wskazanego typu do obszaru, na którym masz już co najmniej jednego meepla tego typu (rycerz do rycerza, podróżnik do podróżnika, chłop do chłopa).',
          'B) Zdejmij jednego swojego meepla wskazanego typu z planszy do zapasu.',
          'Grabie: chłopi na polach. Maczuga: podróżnicy na drogach. Tarcza: rycerze w miastach.',
        ],
      },
      {
        type: 'exception',
        text: 'Jeśli nie masz na planszy żadnej figury wskazanego typu i to Ty położyłeś kafelek, i tak musisz wybrać A albo B (choć możesz nie mieć jak wykonać A). Jeśli nie masz takiej figury i to nie Ty kładłeś kafelek, pomijasz akcję.',
      },
      {
        type: 'example',
        title: 'Przykład A (tarcza)',
        text: 'Kładziesz krąg-tarczę, stawiasz rycerza i wybierasz A. Zielony dokłada rycerza do swojego miasta. Niebieski nie ma rycerzy — nic nie robi. Ty dokładasz drugiego rycerza do miasta, w którym już masz rycerza (nie możesz wybrać pustego miasta).',
      },
      {
        type: 'example',
        title: 'Przykład B (grabie)',
        text: 'Zielony kładzie krąg-grabie, kończy miasto, potem wybiera B. Niebieski zdejmuje chłopa, Ty zdejmujesz chłopa, zielony nie ma chłopów i nic nie robi.',
      },
      {
        type: 'heading',
        text: 'Punktowanie i koniec gry',
        level: 2,
      },
      {
        type: 'paragraph',
        text: 'Akcja kręgu sama w sobie nie przyznaje punktów — zmienia tylko obecność figur. Punktowanie obszarów odbywa się w etapie 3 przed akcją kręgu. Na końcu gry obowiązują standardowe zasady; kręgi nie dają osobnej premii końcowej.',
      },
      {
        type: 'commonMistake',
        text: 'Wykonywanie akcji kręgu przed punktowaniem albo dokładanie figury do obszaru bez własnej figury tego typu.',
      },
    ],
  },
];

export const miniSections = upgradeMiniChapters(miniSectionsRaw);
